import React from "react";

/**
 * Desktop-only column wrappers. When `on` is false they render their children
 * unwrapped, so the phone DOM is identical to the pre-redesign markup.
 */
export function DeskGrid({ on, className = "", children }) {
  return on ? <div className={`ops-grid ${className}`.trim()}>{children}</div> : <>{children}</>;
}

export function DeskCol({ on, className = "", children }) {
  return on ? <div className={`ops-col ${className}`.trim()}>{children}</div> : <>{children}</>;
}
